import React from 'react';
import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { keys } from 'lodash';
import { ApiClient } from 'services';
import { PendingButton } from 'components/common';
import { NotificationManager } from 'react-notifications';

const ConfirmModal = ({ isOpen, toggle, numSelected, onConfirm, pending, question }) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalBody>
      {question(numSelected)}
    </ModalBody>
    <ModalFooter>
      <PendingButton color="primary" pending={pending} onClick={onConfirm}>
        Confirm
      </PendingButton>{' '}
      <Button color="secondary" onClick={toggle}>
        Cancel
      </Button>
    </ModalFooter>
  </Modal>
);

const enhance = compose(
  withState('pending', 'setPending', false),
  withPropsOnChange(['selected'], ({ selected: tmpSelected }) => {
    const selected = keys(tmpSelected);

    return {
      numSelected: selected.length,
      selected,
    };
  }),
  withHandlers({
    onConfirm: ({
      apiRequest, 
      onConfirm,
      selected,
      onApiRequest,
      isOpen,
      toggle,
      setPending,
    }) => () => {
      setPending(true);
      let promise = null;
      const failed = [];
      if (onConfirm) {
        promise = onConfirm();
      } else {
        promise = Promise.mapSeries(
          selected,
          i =>
            apiRequest(i).catch(() => {
              failed.push(i);
            }),
          { concurrency: 1 }
        ).tap(() => {
          if (failed.length) {
            NotificationManager.error(
              `${failed.length} row${
                failed.length > 1 ? 's' : ''
              } did not succeed`
            );
          }
        });
      }

      promise
        .tap(() => {
          if (isOpen) toggle();
          onApiRequest(failed.length ? failed : null);
        })
        .finally(() => setPending(false));
    },
  })
);

export default enhance(ConfirmModal);



// WEBPACK FOOTER //
// ./src/components/common/Tables/ConfirmModal.jsx